import { jsx } from "react/jsx-runtime";
import "react";
import { mapPinType } from "../../constants/index.js";
import { Box } from "pcln-design-system";
import { Activity, Attraction, Beach, Departure, KingBed, Mountain, Museum, Park, Pin, Restaurant, Train } from "pcln-icons";
import styled_components from "styled-components";
const IconBox = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "SinglePinIcon__IconBox"
})([
    "border-radius:50%;box-shadow:0 -1px 0 0 rgba(0,0,0,0.03),0 0 2px 0 rgba(0,0,0,0.2),0 4px 2px -2px rgba(0,0,0,0.12),0 4px 8px -1px rgba(0,0,0,0.16);width:24px;height:24px;background:linear-gradient( 132.8deg,#7701bb 12.64%,#7601bb 17.94%,#7503bc 23.08%,#7205bd 28.07%,#6e09bf 32.93%,#690dc1 37.69%,#6312c4 42.36%,#5c18c7 46.96%,#541fca 51.52%,#4c27ce 56.05%,#422fd2 60.57%,#3738d7 65.11%,#2c42dc 69.68%,#204de1 74.31%,#1358e7 79.01%,#0564ed 83.8% ),radial-gradient( 90.13% 94.81% at 14.57% 5.35%,rgba(245,235,250,0.7) 0%,rgba(238,222,246,0.605208) 16.15%,rgba(232,210,243,0.514991) 33.33%,rgba(209,168,232,0.203394) 66.15%,rgba(201,153,228,0.0965608) 82.29%,rgba(194,140,224,0) 100% ),radial-gradient( 33.32% 66.63% at 81.46% 89.53%,rgba(232,242,255,0.3) 0%,rgba(232,242,255,0.3) 0.01%,rgba(153,195,249,0) 100% );svg{transform:translate(25%,24%);height:16px;width:16px;}"
]);
const MapIcon = ({ type, iconProp })=>{
    switch(type){
        case mapPinType.MUSEUM:
            return /*#__PURE__*/ jsx(Museum, {
                ...iconProp
            });
        case mapPinType.BEACH:
            return /*#__PURE__*/ jsx(Beach, {
                ...iconProp
            });
        case mapPinType.RESTAURANT:
            return /*#__PURE__*/ jsx(Restaurant, {
                ...iconProp
            });
        case mapPinType.HOTEL:
            return /*#__PURE__*/ jsx(KingBed, {
                ...iconProp
            });
        case mapPinType.AIRPORT:
            return /*#__PURE__*/ jsx(Departure, {
                ...iconProp
            });
        case mapPinType.MOUNTAIN:
            return /*#__PURE__*/ jsx(Mountain, {
                ...iconProp
            });
        case mapPinType.PARK:
            return /*#__PURE__*/ jsx(Park, {
                ...iconProp
            });
        case mapPinType.ACTIVITY:
            return /*#__PURE__*/ jsx(Activity, {
                ...iconProp
            });
        case mapPinType.ATTRACTION:
        case mapPinType.POI:
            return /*#__PURE__*/ jsx(Attraction, {
                ...iconProp
            });
        case 'TRANSIT':
            return /*#__PURE__*/ jsx(Train, {
                ...iconProp
            });
        case 'CITY':
        default:
            return /*#__PURE__*/ jsx(Pin, {
                ...iconProp
            });
    }
};
const SinglePinIcon = ({ type })=>/*#__PURE__*/ jsx(IconBox, {
        bg: "background.lightest",
        "data-testid": "single-pin-icon",
        children: /*#__PURE__*/ jsx(MapIcon, {
            type: type,
            iconProp: {
                color: 'text.lightest'
            }
        })
    });
export { MapIcon, SinglePinIcon };
